import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
    id: string;
}

function SortableItem({ id, children }:Props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id });
    return (
        <div ref={setNodeRef}
            {...attributes}
            {...listeners}
            style={{
                width: '100%',
                transform: CSS.Transform.toString(transform),
                transition,
                zIndex: isDragging ? '100' : undefined,
            }}>
            {children}
        </div>
    );
}

export default SortableItem;
